<div class="card-header">
  <app-breadcrumb></app-breadcrumb>
  <ng-container *ngIf="userService.isAdmin()">
    <div class="menu" [matMenuTriggerFor]="menu">
      <span class="material-icons white">more_vert</span>
    </div>
    <mat-menu #menu="matMenu" xPosition="before">
      <button mat-menu-item [routerLink]="'/bewind/' + account?.clientId">
        <mat-icon>person</mat-icon>
        <span>naar client</span>
      </button>
      <button mat-menu-item routerLink="debugging">
        <mat-icon>bug_report</mat-icon>
        <span>debugging</span>
      </button>
    </mat-menu>
  </ng-container>
</div>
<app-bigger-screen-required></app-bigger-screen-required>
<div *ngIf="account" class="card-body hide-on-phone">
  <div class="flex bigger mt14">
    <div class="col-4">
      <span class="light inline-block mr16">rekening:</span> <span class="medium">
      {{account.accountCategory.name}}
    </span>
    </div>
    <div class="col-4">
      <span class="light inline-block mr16">laatste saldo:</span> <span class="medium">
      {{currency.symbol(account.currency)}}{{currency.format(account.saldo)}}
    </span>
    </div>
    <div class="col-4">
      <span class="light inline-block mr16">laatste datum:</span> <span class="medium">{{account.lastUpload}}</span>
    </div>
  </div>
  <div class="spacer-small"></div>

  <p *ngIf="account.accountCategory.id == 512"> <!-- Beheer/Betaal -->
    U gebruikt de rekening voor het betalen en beheren van de vaste inkomsten en uitgaven van de onder bewind gestelde.<br>
    U beheert deze rekening met behulp van internetbankieren.
  </p>
  <p *ngIf="account.accountCategory.id == 515"> <!-- Leefgeld -->
    De onder bewind gestelde beschikt zelf over deze rekening voor dagelijkse uitgaven. De inkomsten en uitgaven op de
    leefgeldrekening hoeven niet te worden gespecificeerd in de rekening en verantwoording.
    Reveon telt de interne overboekingen tussen de rekeningen automatisch op.
  </p>
  <div class="spacer"></div>

  <mat-tab-group (selectedTabChange)="tabInit($event)">
    <mat-tab *ngIf="!isLeefgeldRekening"
             label="niet gecategoriseerde transacties ({{count}})">
      <app-transaction-unassigned (assign)="assign()"
                                  (change)="unassignedCount($event)"
                                  (undoAssignment)="undo()"
                                  [accountId]="account?.id"></app-transaction-unassigned>
    </mat-tab>
    <mat-tab label="gecategoriseerde transacties ({{countAssigned}})">
      <app-transaction-assigned (change)="assignedCount($event)"
                                [isLeefgeldRekening]="isLeefgeldRekening"
                                (withdrawAssignmentUpdateCounter)="withdrawAssignmentUpdateCounter()"
                                [accountId]="account?.id">
      </app-transaction-assigned>
    </mat-tab>
  </mat-tab-group>
</div>
